import React from 'react';
import { useTranslation } from 'react-i18next';

interface LoadingOverlayProps {
  message?: string;
  showSpinner?: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({
  message,
  showSpinner = true
}) => {
  const { t } = useTranslation();
  const displayMessage = message ?? t('common.loading');
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-white bg-opacity-90">
      <div className="text-center">
        {showSpinner && (
          <div className="mb-4">
            <svg className="animate-spin h-12 w-12 text-blue-600 mx-auto" fill="none" viewBox="0 0 24 24">
              <circle 
                className="opacity-25" 
                cx="12" 
                cy="12" 
                r="10" 
                stroke="currentColor" 
                strokeWidth="4"
              />
              <path 
                className="opacity-75" 
                fill="currentColor" 
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          </div>
        )}
        
        <p className="text-lg font-medium text-gray-900">{displayMessage}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay; 